import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaCookie } from 'react-icons/fa';
import SEOMetadata from '../SEOMetadata/SEOMetadata';

const Cookies = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFEEED] to-white">
        <SEOMetadata 
        title="Cookie Policy | PhDScanner"
        description="Learn how PhDScanner uses cookies to enhance your browsing experience and how you can manage your cookie preferences."
        keywords="cookie policy, PhDScanner cookies, website cookies, privacy settings,phd jobs, university jobs, jobs"
        imageUrl="https://www.phdscanner.com/phdscanner_logo.webp"
        url="https://www.phdscanner.com/cookies"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Back Button */}
        <Link 
          to="/" 
          className="mb-8 inline-flex items-center text-[#DB4F40] hover:text-[#C64537] font-medium transition-colors"
        >
          <FaArrowLeft className="mr-2" />
          Back to Home
        </Link>

        {/* Hero Section */}
        <div className="text-center mb-16">
          <div className="bg-[#DB4F40]/10 rounded-full p-4 inline-block mb-6">
            <FaCookie className="text-4xl text-[#DB4F40]" />
          </div>
          <h1 className="text-4xl font-extrabold text-[#1B222A] mb-4">
            Cookie Policy
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We use cookies to enhance your experience while using our services.
          </p>
        </div>

        {/* Content Container */}
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 border border-[#DB4F40]/20">
          {/* What Are Cookies Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-[#1B222A] mb-6">
              What Are Cookies?
            </h2>
            
            <div className="space-y-4 text-gray-700">
              <p>
                Cookies are small text files stored on your device when you visit websites. They help websites remember information about your visit.
              </p>
              <p>
                We use cookies to make our website work properly and to provide you with a better browsing experience.
              </p>
            </div>
          </section>

          {/* How We Use Cookies Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-[#1B222A] mb-6">
              How We Use Cookies
            </h2>
            
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-[#DB4F40]/10">
                    <th className="px-6 py-4 text-left text-[#C64537] font-semibold border-b-2 border-[#DB4F40]">
                      Cookie Name
                    </th>
                    <th className="px-6 py-4 text-left text-[#C64537] font-semibold border-b-2 border-[#DB4F40]">
                      Purpose
                    </th>
                    <th className="px-6 py-4 text-left text-[#C64537] font-semibold border-b-2 border-[#DB4F40]">
                      Duration
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="hover:bg-[#FFEEED]/50 transition-colors">
                    <td className="px-6 py-4 border-b border-[#DB4F40]/20">
                      <code className="text-[#DB4F40] bg-[#FFEEED] px-2 py-1 rounded">
                        session_id
                      </code>
                    </td>
                    <td className="px-6 py-4 border-b border-[#DB4F40]/20">
                      Maintains your secure login session
                    </td>
                    <td className="px-6 py-4 border-b border-[#DB4F40]/20">
                      Browser session
                    </td>
                  </tr>
                  <tr className="hover:bg-[#FFEEED]/50 transition-colors">
                    <td className="px-6 py-4 border-b border-[#DB4F40]/20">
                      <code className="text-[#DB4F40] bg-[#FFEEED] px-2 py-1 rounded">
                        preferences
                      </code>
                    </td>
                    <td className="px-6 py-4 border-b border-[#DB4F40]/20">
                      Stores your site preferences
                    </td>
                    <td className="px-6 py-4 border-b border-[#DB4F40]/20">
                      30 days
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="mt-6 text-gray-600 text-sm italic">
              * No third-party cookies or tracking mechanisms are employed on our platform.
            </p>
          </section>

          {/* Managing Cookies Section */}
          <section className="mb-12">
            <h2 className="text-3xl font-bold text-[#1B222A] mb-6">
              Managing Cookies
            </h2>
            
            <div className="space-y-4 text-gray-700">
              <p>
                You can control and/or delete cookies as you wish. You can delete all cookies that are already on your computer and set most browsers to prevent them from being placed.
              </p>
              <p>
                If you do this, however, you may have to manually adjust some preferences every time you visit a site and some services and functionalities may not work.
              </p>
            </div>
          </section>

          {/* Contact Section */}
          <section>
            <h3 className="text-2xl font-bold text-[#1B222A] mb-4">
              Need More Information?
            </h3>
            <p className="text-gray-700 mb-4">
              Contact our admin at:
            </p>
            <a 
              href="mailto:admin@phdscanner.com" 
              className="text-[#DB4F40] hover:text-[#C64537] font-medium transition-colors"
            >
              admin@phdscanner.com
            </a>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Cookies;